import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';

const IngredientEditDialog = ({ open, ingredient, onClose, onSave }) => {

    const isEditing = !!ingredient;

    const [formData, setFormData] = useState({
        name: '',
        measurement: '',
        category: '',
    });

    // TODO: Add useEffect to update formData when ingredient changes
    useEffect(() => {
        if (ingredient) {
            setFormData({
                name: ingredient.name || '',
                measurement: ingredient.measurement || '',
                category: ingredient.category || '',
            });
        } else {
            setFormData({
                name: '',
                measurement: '',
                category: '',
            });
        }
    }, [ingredient]);

    const handleInputChange = (field) => (event) => {
        setFormData(prev => ({
            ...prev,
            [field]: event.target.value
        }));
    };

    const handleSave = () => {
        onSave(formData);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {isEditing ? `Edit: ${ingredient?.name}` : `Add New ingredient`}
            </DialogTitle>

            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    {/* TODO: Add TextField for ingredient name */}
                    <TextField
                        label="Ingredient Name"
                        value={formData.name}
                        onChange={handleInputChange('name')}
                        fullWidth
                    />

                    {/* TODO: Add TextField for description */}
                    <TextField
                        label="Measurement"
                        value={formData.measurement}
                        onChange={handleInputChange('measurement')}
                        fullWidth
                    />

                    {/* TODO: Add TextField for style */}
                    <TextField
                        label="category"
                        value={formData.category}
                        onChange={handleInputChange('category')}
                        fullWidth
                    />

                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained">Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default IngredientEditDialog;